
import React from 'react';
import { AdminAppConfigManagement } from './AdminAppConfigManagement';
import { AdminVisibilityMatrixSection } from './AdminVisibilityMatrixSection';
import { AppUser } from '../../../types';

interface SuperAdminAppManagementSectionProps {
    appUser: AppUser | null;
}

export const SuperAdminAppManagementSection: React.FC<SuperAdminAppManagementSectionProps> = ({ appUser }) => {
  return (
    <div id="super-admin-app-config" role="tabpanel" className="space-y-10">
        <AdminAppConfigManagement />
        <div className="border-t border-gray-100 pt-10">
            <AdminVisibilityMatrixSection appUser={appUser} />
        </div>
    </div>
  );
};
